import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import classNames from 'classnames';
import svgStyles from './SVGStyles.module.css';

export default function PosterListSvg({ className }: StandardSvgProps) {
	return <svg className={classNames(svgStyles.SDefaultSvg, className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.593 15.593">
		<rect width="3.713" height="6.683" rx="1" />
		<rect width="3.713" height="6.683" rx="1" transform="translate(5.94)" />
		<rect width="3.713" height="6.683" rx="1" transform="translate(11.88)" />
		<rect width="3.713" height="6.683" rx="1" transform="translate(0 8.91)" />
		<rect width="3.713" height="6.683" rx="1" transform="translate(5.94 8.91)" />
		<rect width="3.713" height="6.683" rx="1" transform="translate(11.88 8.91)" />
	</svg>
}
